module.exports = __webpack_public_path__ + "static/media/cloudComputing.cc886e85.jpg";